import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElTooltip } from "element-plus";
import "element-plus/dist/index.css";
import Placement from "./models/ToolTip";

interface Props {
  placement: Placement;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    placement: null
  },
  setup(__props: any) {

const props = __props as {
  placement: Placement;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElTooltip), {
    placement: props.placement
  }, {
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "tooltip")
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "element")
    ]),
    _: 3
  }, 8, ["placement"]))
}
}

})